import React, {useCallback, useState} from 'react';
import {Button, Col, Container, Table} from 'react-bootstrap';
import {httpClient} from "../../service";
import {ActionResult, HttpMethod} from "../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import {Link} from 'react-router-dom';
import {getSessionVerify, TtaSecModel} from '../verifications/VerifyConfigModel';
import T4Detail from './t4Detail';

export const Verification2t4 = () => { // 추가
    const url = 'test/tta4';
    const model=getSessionVerify();

    const [loading, setLoading] = useState<boolean>(false);
    const onDeleteProcess =  useCallback(async(e: any) => {
        e.preventDefault();
        const ans = window.confirm("검증데이타를 초기화 하시겠습니까? 초기화하면 현재 검증데이타가 삭제됩니다.");
        if (ans == false) return false;
        console.log(`click button id=${e.target}`);
        setLoading(true);
        const url = `test/tta`;
        const options = {
            method: HttpMethod.DELETE,
            url,
            body: {...model, ttaNum: 4}
        }
        const act = await httpClient(options);
        setLoading(false);
        if (act.result) {
            window.location.reload();
            alert("성공적으로 초기화 되었습니다.");
        } else {
            alert(act.errorMsg);
        }
    },[]);

    const options = {promiseFn: httpClient, method: HttpMethod.GET, url,body: model};

    const {data: act, error, isLoading} = useAsync<ActionResult>(options);
    const refresh=useCallback(async()=>{
        window.location.reload();
    },[]);
    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage action={act}/>;
    const data: TtaSecModel[] = act.data;

    return (
        <>
            <div className="bloc l-bloc">
                <Container className="bloc-sm verify-bloc">
                    <div className="row mb-1">
                        <Col className="text-left col-sm-4">
                            <Link to="/verification2" className="btn btn-sm btn-primary">Home</Link>
                            &nbsp;
                            <Link to="/verification2/config" className="btn btn-sm btn-info">환경설정</Link>
                            &nbsp;
                            <Button className="btn-danger" size="sm" onClick={onDeleteProcess}
                                    disabled={loading}>초기화</Button>
                        </Col>
                        <Col className={'text-center col-sm-4'}>
                            검증4
                        </Col>
                        <Col className="text-right col-sm-4">
                            [상점명: <span className="text-primary">{model.shopNm4}</span>, 회원번호: <span className="text-primary">{model.custNo}</span>]
                        </Col>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <Table striped bordered hover size="sm" variant="dark" className={'tta'}>
                                <colgroup>
                                    <col style={{width: '40px'}}/>
                                    <col style={{width: '100px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '150px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th rowSpan={2}>#</th>
                                    <th rowSpan={2}>SSO KEY</th>
                                    <th rowSpan={2}>스탬프<br />수량</th>
                                    <th rowSpan={2}>적립 매장</th>
                                    <th rowSpan={2}>사용가능<br />쿠폰수량</th>
                                    <th rowSpan={2}>로그인 일시</th>
                                    <th rowSpan={2}>계정전환<br />결과</th>
                                    <th rowSpan={2}>적립QR</th>
                                    <th rowSpan={2}>적립조건</th>
                                    <th colSpan={3}>적립결과</th>
                                    <th rowSpan={2}>사용가능<br />쿠폰수량</th>
                                    <th rowSpan={2}>검증</th>
                                </tr>
                                <tr>
                                    <th>스탬프 수량</th>
                                    <th>적립 매장</th>
                                    <th>쿠폰수량</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data &&  data.map((item, i) => {
                                        return <T4Detail item={item} key={i} index={i} model={model}/>
                                    })
                                }
                                </tbody>
                            </Table>
                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
};

